import React from 'react';

const PaymentOptions = ({ 
  paiementFraisInscription, 
  setPaiementFraisInscription, 
  fraisInscription, 
  montantScolarite, 
  premiereTrancheModalite, 
  montantPremiereTranche, 
  paiementComplet,
  tarifsSup,
  optionsPaiement,
  setOptionsPaiement,
  formData
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Paiement</h3>
      <div className="bg-white shadow rounded-lg p-6">
        <div className="space-y-4">
          {/* Frais d'inscription */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id="paiementFraisInscription"
                checked={paiementFraisInscription}
                onChange={(e) => setPaiementFraisInscription(e.target.checked)}
                className="h-4 w-4 text-[#202654] focus:ring-[#202654] rounded"
              />
              <label htmlFor="paiementFraisInscription" className="text-sm font-medium text-gray-700">
                Frais d'inscription
              </label>
            </div>
            <span className="font-medium">{fraisInscription.toLocaleString()} FCFA</span>
          </div>

          {/* Frais de scolarité */}
          <div className="border-t pt-2">
            <div className="flex justify-between text-sm mb-2">
              <span className="font-medium">Frais de scolarité:</span>
              <span className="font-medium text-[#202654]">{montantScolarite.toLocaleString()} FCFA</span>
            </div>
            {!paiementComplet && premiereTrancheModalite && (
              <div className="text-xs text-gray-600">
                Première tranche ({premiereTrancheModalite.pourcentage}%): {montantPremiereTranche.toLocaleString()} FCFA
              </div>
            )}
          </div>
          
          {/* Options complémentaires */}
          {tarifsSup.length > 0 && (
            <div className="border-t pt-2">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Options complémentaires:</h4>
              {tarifsSup.map(tarif => (
                <div key={tarif.id} className="flex items-center justify-between text-sm mb-2">
                  <div className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      id={`paiement-option-${tarif.id}`}
                      checked={optionsPaiement[tarif.id] || false}
                      onChange={(e) => setOptionsPaiement(prev => ({
                        ...prev,
                        [tarif.id]: e.target.checked
                      }))}
                      className="h-4 w-4 text-[#202654] focus:ring-[#202654] rounded"
                    />
                    <label htmlFor={`paiement-option-${tarif.id}`} className="text-gray-600">
                      {tarif.libelle}
                    </label>
                  </div>
                  <span className="font-medium text-blue-600">{tarif.prix.toLocaleString()} FCFA</span>
                </div>
              ))}
            </div>
          )}
          
          {/* Remise */}
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Remise:</span>
            <span className="font-medium text-green-600">-{formData.remise.toLocaleString()} FCFA</span>
          </div>

          {/* Total */}
          <div className="border-t pt-2">
            <div className="flex justify-between text-sm">
              <span className="font-medium">Total à payer:</span>
              <span className="font-bold text-[#202654]">{formData.montant_total.toLocaleString()} FCFA</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentOptions;
